import { AssistantContextSubType } from '../types.js';
import { EVERYTHING_CONTEXT } from '../constants.js';
import isString from '../../../node_modules/lodash-es/isString.js';

const getContextKeyFromMessage = (message) => {
  if (!message) return getContextKey(EVERYTHING_CONTEXT);
  const context = message.context;
  return getContextKey(context);
};
const getContextKey = (context) => {
  const contextValue = isString(context) ? context : JSON.stringify(context?.value);
  return `context:${context?.subType}:${contextValue}`;
};
const fileBaseContextSubtype = [
  AssistantContextSubType.File,
  AssistantContextSubType.Selection
];
const isFileBasedContext = (context) => {
  return fileBaseContextSubtype.includes(context?.subType ?? AssistantContextSubType.Everything);
};

export { getContextKey, getContextKeyFromMessage, isFileBasedContext };
//# sourceMappingURL=context.js.map
